import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

/**
 * @description
 * Guard to redirect from old 'water-safety' routes to new 'water-safety-iq' routes.
 * replaces 'water-safety' with 'water-safety-iq' in the URL and navigates to the new route.
 * If the URL does not start with 'water-safety', navigation is allowed to proceed.
 * 
 * @returns
 * returns false if a redirection occurs, true otherwise.
 */
@Injectable({
    providedIn: 'root'
})
export class wsiRedirectGuard  {
    public constructor(private router: Router) { }

    public canActivate(route: ActivatedRouteSnapshot): boolean {
        const url = route.url.map(segment => segment.path).join('/');
        if (url.startsWith('water-safety')) {
            const newUrl = url.replace('water-safety', 'water-safety-iq');
            void this.router.navigateByUrl(`/${newUrl}`, { replaceUrl: true });
            return false;
        }
        // Allow navigation otherwise
        return true;
    }
}
